export const BrowserPopupBlockedErrorName = "BrowserPopupBlockedError";

export class BrowserPopupBlockedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = BrowserPopupBlockedErrorName;
  }
}
